import { render, staticRenderFns } from "./DataConsegna.vue?vue&type=template&id=3a7734e4&"
import script from "./DataConsegna.vue?vue&type=script&lang=ts&"
export * from "./DataConsegna.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports